import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import PricingCard from "../PricingCard/PricingCard";
import landingData from "./data";
import styles from "./LandingCards.module.css";

const LandingCards = () => {
  return (
    <Container>
      <Row className="pb-4">
        {landingData.map((item, i) => (
          <Col key={i} md={4} className="py-4">
            <PricingCard {...item} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default LandingCards;
